import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { useFleet } from '../hooks/useFleet';
import { useHasPermission } from '../hooks/useHasPermission';
import { EventType, Fleet } from '../interfaces';
import { FleetService } from '../services';

export const useAllFleetsEventTypesQuery = () => {
  const hasPermission = useHasPermission('events:read:resource');

  const queryKey = ['allFleetsEventType-key'];

  const queryFn = () => FleetService.getAllFleetsEventTypes();
  return useQuery({
    queryKey,
    queryFn,
    enabled: hasPermission,
    defaultData: [] as EventType[],
  });
};

export const useFleetEventTypesQuery = (fleetParam?: Fleet) => {
  const fleetFromContext = useFleet();
  const fleet = fleetParam || fleetFromContext;
  const hasPermission = useHasPermission('events:read:resource');

  const fleetUuid = fleet?.uuid;

  const queryKey = ['fleetEventTypes-key', fleetUuid];

  const queryFn = () => FleetService.getFleetEventTypes(fleetUuid);

  return useQuery({
    queryKey,
    queryFn,
    enabled: hasPermission && !!fleetUuid,
    defaultData: [] as EventType[],
  });
};

export const forceRefreshEventTypes = (fleetUuid: Fleet['uuid']) => {
  queryClient.invalidateQueries(['fleetEventTypes-key', fleetUuid]);
};

export const forceRefreshAllFleetsEventTypes = () => {
  queryClient.invalidateQueries(['allFleetsEventType-key']);
};
